import {
    /** FETCH PROFESSIONS  */
    FETCH_PAYMENT_FULFILLED,
    FETCH_PAYMENT_REJECTED,
    FETCH_PAYMENT_PENDING,
    RESET

} from "../../actions/application/payment";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PAYMENT_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_PAYMENT_FULFILLED:

            return {
                ...state,
                payment: action.payload,
                done: true,
                error: false,
                spinner: false
            };
        case FETCH_PAYMENT_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET:
            return {
                initialState,
                done: false,
                error: {},
            };
        default:
            return state;
    }
};